<template>
  <div class="three-dimensional">
    <!-- spu名称是否做过长截断 -->
    <CommonPopup
      ref="popup"
      v-if="isShow"
      :isThreeDimensional="isShow"
      v-show="isShow"
      @close="closeFn"
      @buy="buy"
      :canBuy="canBuy"
      :title="spuName"
      prevent-crash
    >
      <!-- 能不能对iframe最缓存 -->
      <!-- 360度展示页曝光时上报 -->
      <iframe
        @load="load"
        :class="['iframe', isSixVerion ? 'isSixVerion' : '']"
        title="iframe"
        :src="threeDimensionalUrl"
        v-track="{
          act: 'show',
          params: { cfrom: '207|002|02|077', event_id: '207|002|02|077', sku_id: skuId }
        }"
      />
    </CommonPopup>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import CommonPopup from '../common-popup'
import API from 'api'

export default {
  name: 'ThreeDimensional',
  components: {
    CommonPopup
  },
  props: {
    isShow: Boolean, // 是否展示
    threeDimensionalUrl: String, // 3Durl
    canBuy: Boolean, // 是否可以购买
    isSixVerion: Boolean
  },
  watch: {
    // 离开埋点上报
    isShow(val) {
      if (val) {
        this.previewEnterTime = new Date().getTime()
      } else {
        let duration = new Date().getTime() - this.previewEnterTime
        // 360度展示页-离开
        API.logAll({
          cfrom: '207|002|98|077',
          event_id: '207|002|98|077',
          sku_id: this.skuId,
          duration
        })
      }
    }
  },
  computed: {
    ...mapGetters('detailv3', ['spuId', 'skuId']),
    ...mapState('detailv3', ['spuInfo']),
    spuName() {
      return this.spuInfo?.commoditySpu?.spuName
    }
  },
  data() {
    return {
      previewEnterTime: ''
    }
  },
  methods: {
    ...mapActions('detailv3', ['showSkuSelect']),
    /**
     * 关闭弹框
     */
    closeFn() {
      this.$emit('close', false)
    },
    buy() {
      this.showSkuSelect({
        isShow: true
      })
      // 360度展示页购买按钮点击
      API.logAll({
        cfrom: '207|003|01|077',
        event_id: '207|003|01|077',
        sku_id: this.skuId
      })
    },
    load() {
      this.$refs.popup.frameLoad()
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe {
  width: 100vw;
  height: 100%;
  background: #fff;
  &.isSixVerion {
    height: 90vh;
    background: #fff;
  }
}
</style>
